export type Server = 'dev' | 'staging' | 'global' | 'china'

export interface UserInfo {
  user_type: 'legacy' | 'seekr_id' | 'guest'
  user_id: number
  server: Server
  token: string
}

export type Result<Data, Error = null> =
  | { success: true; data: Data }
  | (Error extends null ? { success: false } : { success: false; error: Error })

export interface ProductMetadata {
  receipt_system_product_id: number
  product_id: number
  product_type: 'consumable' | 'subscription'
  sku: string
}

export type PaymentPlatform = 'ios' | 'googleplay_android' | 'china_android'

export type PaymentSystemIdByPlatform = Record<PaymentPlatform, number>

export type ServiceApiPlatform = 'ios' | 'android' | 'android-cn'

export function mapPlatformToServiceApi(
  platform: PaymentPlatform,
): ServiceApiPlatform {
  switch (platform) {
    case 'ios':
      return 'ios'
    case 'googleplay_android':
      return 'android'
    case 'china_android':
      return 'android-cn'
  }
}

/**
 * Payload for the native IAP `purchase` call (native ≥ 5.19.0). Discriminated on
 * `product_type`: only subscriptions carry an offer. `offer_id` selects which
 * offer to apply; `offer_compact_jws` is the signed token iOS needs for a
 * *promotional* offer (Android omits it). See docs/adr/0003.
 */
export type PurchasePayload =
  | {
      product_type: 'consumable'
      product_id?: number
      sku: string
      receipt_system_account_id?: string | null
    }
  | {
      product_type: 'subscription'
      product_id?: number
      sku: string
      offer_id?: string
      offer_compact_jws?: string
      receipt_system_account_id?: string | null
    }
